import { render, staticRenderFns } from "./SelectUserCheckbox.vue?vue&type=template&id=15bf7bc8&scoped=true&"
import script from "./SelectUserCheckbox.vue?vue&type=script&lang=js&"
export * from "./SelectUserCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf7bc8",
  null
  
)

export default component.exports